import { render } from "./LazySelect.vue?vue&type=template&id=04cfca48"
import script from "./LazySelect.vue?vue&type=script&lang=js"
export * from "./LazySelect.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__